import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { KeyValue } from '../../shared/key-value';
import { AuthorizationService } from '../../shared/authorization.service';
import { IDatasource, IGetRowsParams, GridOptions, GridApi } from 'ag-grid-community';
import { ResetPasswordRenderer } from './reset-password-button.component';
import { WorksessionDetails } from './worksession-details.component';
// import { NguiPopupComponent, NguiMessagePopupComponent } from '@ngui/popup';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-admin-find-user',
  templateUrl: './admin-find-user.component.html',
  styleUrls: ['./admin-find-user.component.css']
})
export class AdminFindUserComponent implements OnInit {
  private gridColumnApi;
  gridApi: GridApi;
  context;
  frameworkComponents: any;
  user: any = {};
  event: any;
  activeFilterColumn: string = '';
 
  // @ViewChild(NguiPopupComponent) popup: NguiPopupComponent;

  columnDefs = [
    {
      headerName: 'First name',
      field: 'first_name',
      width: 100,
      filter: true,
      
      filterParams: {
        filterOptions: ['contains'],
        suppressAndOrCondition: true,
      },
      lockPosition: true,
      onFilterChanged: () => this.clearOtherFilters('first_name'), 
    },
    {
      headerName: 'Last name',
      field: 'last_name',
      width: 100,
      filter: true,
    filterParams: {
      filterOptions: ['contains'],
    
      suppressAndOrCondition: true, 
    },
      lockPosition: true,
      onFilterChanged: () => this.clearOtherFilters('last_name'), 
    },
    {
      headerName: 'Email address',
      field: 'email',
      width: 180,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
       
        suppressAndOrCondition: true,
      },
      lockPosition: true,
      onFilterChanged: () => this.clearOtherFilters('email'), 
    },
    {
      headerName: 'Role',
      field: 'role',
      width: 100,
      suppressFilter: true,
      lockPosition: true
    },
    {
      headerName: 'Sessions enrolled',
      field: 'sessions_enrolled',
      width: 200,
      suppressFilter: true,
      id: 'sessions',
      cellRenderer: 'worksessionDetails',
      cellStyle: { 'overflow-y': 'auto' },
      colId: 'params',
      lockPosition: true
    },
    {
      headerName: 'Reset password',
      field: 'reset_password',
      cellRenderer: 'resetPasswordRenderer',
      colId: 'params',
      width: 180,
      suppressFilter: true,
      lockPosition: true
    }
  ];

  gridOptions: GridOptions = {
    // filter: true,
    pagination: true,
    suppressCellSelection: true,
    rowModelType: 'infinite',
    cacheBlockSize: 10,
    paginationPageSize: 10
  };

  constructor(public authService: AuthorizationService,private KeyValueService: KeyValue, private router: Router) {
    this.context = { componentParent: this };
    this.frameworkComponents = {
      resetPasswordRenderer: ResetPasswordRenderer,
      worksessionDetails: WorksessionDetails
    };
  }

  ngOnInit() { }

  apiService(reqParmas: any) {
    return this.authService.get(KeyValue.api_users, { params: reqParmas })
      .pipe(map(res => res));
  }

  dataSource: IDatasource = {
    getRows: (params: IGetRowsParams) => {
      let reqParmas = {};
      reqParmas['start_offset'] = params.startRow;
      reqParmas['end_offset'] = params.endRow;
      reqParmas['filter_name'] = this.filterName();
      reqParmas['filter_value'] = this.filterValue(this.gridApi.getFilterModel());
      // this.clearOtherFilters();
      this.apiService(reqParmas).subscribe(data => {
        params.successCallback(
          data.users,
          data.total_records
        );
      });
    }
  }

  onFilterModified(event) {
    this.gridApi.setDatasource(this.dataSource);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.dataSource);
  }

  filterName() {
    return Object.keys(this.gridApi.getFilterModel());
  }
  filterStatus = {
    first_name: false,
    last_name: false,
    email: false
  };

  clearOtherFilters(columnKey: string) {
    // Clear filters on all columns
    for (const key in this.filterStatus) {
      if (this.filterStatus[key]) {
        this.gridApi.destroyFilter(key);
        this.filterStatus[key] = false;
      }
    }
  
    // Set the filter status for the current column
    this.filterStatus[columnKey] = true;
  
    // Apply the filter to the specified column
    this.gridApi.setFilterModel({ [columnKey]: { filterType: 'text', type: 'contains', filter: '' } });
  }
  
  

  filterValue(data) {
    let val = '';
    const values = Object.keys(data).map(key => data[key]);
    if (values[values.length - 1]) {
      val = values[values.length - 1]['filter'];
    }
    if (Object.keys(data).indexOf("email") != -1) {
      val = this.encodeSpecialCharacterForEmail(val);
    }
    return val;
  }

  encodeSpecialCharacterForEmail(val) {
    val = val.split('@').join('%40');
    val = val.split(':').join('%3A');
    val = val.split('$').join('%24');
    val = val.split(',').join('%2C');
    val = val.split(';').join('%3B');
    val = val.split('?').join('%3F');
    val = val.split('/').join('%2F');
    val = val.split('+').join('%2B');
    return val
  }

  invokeParentMethod(params: any) {
    console.log(params);
    this.user.email = params.email
    this.showResetPasswordDialog();
  }

  navigateTiAdminHomePage() {
    this.router.navigate([KeyValue.adminPath]);
  }

  showResetPasswordDialog() {
    document.getElementById('reset_password_popup_link').click();
  }

  hideResetPasswordDialog() {
    document.getElementById('resetCancel').click();
  }

  revealPassword(id, image_id) {
    const element = (document.getElementById(id) as HTMLInputElement);
    if (element.type === 'password') {
      element.type = 'text';
      (document.getElementById(image_id) as HTMLInputElement).src = 'assets/images/eye.png';
    } else {
      element.type = 'password';
      (document.getElementById(image_id) as HTMLInputElement).src = 'assets/images/eye_img.png';
    }
  }

  clearfields() {
    this.user.newPassword = '';
    this.user.confPassword = '';
    this.user.email = '';
    (document.getElementById('newPassword_img') as HTMLInputElement).src = 'assets/images/eye_img.png';
    (document.getElementById('confPassword_img') as HTMLInputElement).src = 'assets/images/eye_img.png';
    (document.getElementById('newPassword') as HTMLInputElement).type = 'password';
    (document.getElementById('confPassword') as HTMLInputElement).type = 'password';
  }

  resetPassword(userForm) {
    if (userForm.valid) {
      this.submit_reset_password();
    }
  }

  setDefaultResetOptions() {
    this.user = {
      email: '',
      newPassword: '',
      confPassword: '',
      role: ''
    };
  }

  submit_reset_password() {
    this.authService.post(KeyValue.api_reset_password, { member_details: this.user, is_admin: true })
      .pipe(map(res => res)).subscribe(
        data => {
          if (data.status == 200) {
            this.setDefaultResetOptions();
            KeyValue.flash_msg_update({ msg: data.message, type: 'success_messages' });
            this.hideResetPasswordDialog();
          }
          else {
            KeyValue.flash_msg_update({ msg: data.errors, type: 'error_messages' });
          }
        },
        error => {
          console.log('Error...' + error);
        }
      );
    this.clearfields();
  }

  // invokeDeleteUser(params: any){
  //   this.user = params
  //   document.getElementById('ngui-popup-overlay').style.zIndex = '1';
  //   this.popup.open(NguiMessagePopupComponent, {
  //     classNames: 'small',
  //     title: 'Delete User',
  //     message: "Are you sure, you want to delete the user "+ params.email +"?",
  //     buttons: {
  //       OK: () => {
  //         this.deleteUser();
  //         this.popup.close();
  //       },
  //       CANCEL: () => {
  //         this.popup.close();
  //       }
  //     }
  //   });
  // }

  invokeDeleteUser(params: any) {
    this.user = params
    document.getElementById('customPopup').style.display = 'flex';

    const messageElement = document.getElementById('customPopup').querySelector('.popup-message');

    // Set the message text with the email
    messageElement.textContent = "Are you sure you want to delete the user " + params.email + "?";
    // Handle the "OK" button click
    document.getElementById('deleteButton').addEventListener('click', () => {
      this.deleteUser();
      document.getElementById('customPopup').style.display = 'none';
    });
    document.getElementById('cancelButton').addEventListener('click', () => {
      document.getElementById('customPopup').style.display = 'none';
    });
    document.getElementById('closeButton').addEventListener('click', () => {
      document.getElementById('customPopup').style.display = 'none';
    });
  }

  deleteUser() {
    this.authService.delete(KeyValue.api_delete_user + this.user.id, { member_details: this.user, is_admin: true })
      .pipe(map(res => res)).subscribe(
        data => {
          if (data.status === 200) {
            this.gridApi.setDatasource(this.dataSource);
            KeyValue.flash_msg_update({ msg: data.message, type: 'success_messages' });
          } else {
            KeyValue.flash_msg_update({ msg: data.errors, type: 'error_messages' });
          }
        },
        error => {
          console.log('Error...' + error);
        }
      );
  }
}
